<template>
	<section class="container container--medium margin-both-xl">
		<div class="inner">
			<div class="content mdoule-custom-desc" v-if="data.custom_form_title_descrription">
				<h2 class="module-title">{{ data.form_title }}</h2>
				<p v-if="data.form_description" class="description" v-html="data.form_description"></p>
			</div>
			<div
				class="content form-wrap padding-lg"
				:class="{ 'hide-form-desc': data.custom_form_title_descrription }"
				ref="content"
				v-once
			></div>
		</div>
	</section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	name: 'form-picker',
	props: ['data'],
	mounted() {
		const content = this.$refs.content
		const formId = this.data.form_id
		if (formId) {
			this.loadGravityForm2(formId, content)
		}
	},
	methods: {
		...mapActions([
			// 'loadGravityForm'
		]),
		loadGravityForm2(formId, content) {
			const apiUrl = window.WPVUE.home.replace(/\/$/, '') + '/' + window.WPVUE.ajaxurl
			return window.axios
				.get(apiUrl, {
					params: {
						action: 'gf_button_get_form',
						form_id: formId,
					},
				})
				.then((res) => {
					if (typeof window['gformInitDatepicker'] !== 'undefined') {
						window.gformInitDatepicker()
					}
					if (content) {
						window.jQuery(content).html(res.data)
					}
					return res
				})
		},
	},
}
</script>

<style lang="scss">
.module-form_picker {
	.inner {
		background-color: var(--light);
	}
	.form-wrap {
		border: 2px solid var(--dark);
	}
	.module-title {
		margin-top: 0;
	}
	.hide-form-desc {
		.gform_heading {
			display: none !important;
		}
	}
	.content {
	}
}
</style>
